import { render, staticRenderFns } from "./TableGroup.vue?vue&type=template&id=768868d9&"
import script from "./TableGroup.vue?vue&type=script&lang=js&"
export * from "./TableGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports